// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ab-0";
export var optionCard = "_ab-1";